export const notification_read = `subscription notification_read{
    notification_read
}`;
